var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "row" },
    [
      _c("div", { staticClass: "col col-12" }, [
        _c("input", {
          staticClass: "form-control",
          attrs: { readonly: "" },
          domProps: { value: _vm.valueMutable }
        })
      ]),
      _c("div", { staticClass: "col-md-2 mt-1" }, [
        _c("div", { staticClass: "btn-group" }, [
          _vm.level && ["empresa"].indexOf(_vm.level) >= 0
            ? _c(
                "button",
                {
                  directives: [
                    {
                      name: "b-tooltip",
                      rawName: "v-b-tooltip",
                      value: "Editar",
                      expression: "'Editar'"
                    }
                  ],
                  staticClass: "btn btn-outline-secondary",
                  on: { click: _vm.openEdit }
                },
                [
                  _c("span", { staticClass: "material-icons" }, [
                    _vm._v("edit")
                  ])
                ]
              )
            : _vm._e()
        ])
      ]),
      _c(
        "b-modal",
        {
          ref: "modalEdit",
          attrs: {
            id: "modalEdit",
            title: "Editor online",
            size: "xl",
            "hide-footer": ""
          }
        },
        [
          _vm.loadContent
            ? _c("b-spinner", { attrs: { variant: "primary", size: "18" } })
            : _vm._e(),
          !_vm.loadContent
            ? _c("b-card-text", [
                _c("div", { staticClass: "preview" }, [
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-6 col-md-6" },
                      [
                        _c("h4", [_vm._v("Configuración global")]),
                        _c("vue-json-editor", {
                          attrs: {
                            mode: "view",
                            modes: ["view", "code"],
                            "show-btns": false,
                            expandedOnStart: true
                          },
                          model: {
                            value: _vm.global,
                            callback: function($$v) {
                              _vm.global = $$v
                            },
                            expression: "global"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-6 col-md-6" },
                      [
                        _c("h4", [_vm._v("Configuración de la empresa")]),
                        _c("vue-json-editor", {
                          attrs: {
                            mode: "code",
                            modes: ["code"],
                            "show-btns": false,
                            expandedOnStart: true
                          },
                          model: {
                            value: _vm.content,
                            callback: function($$v) {
                              _vm.content = $$v
                            },
                            expression: "content"
                          }
                        })
                      ],
                      1
                    )
                  ])
                ])
              ])
            : _vm._e(),
          _vm.progress.enabled
            ? _c("vs-progress", {
                attrs: {
                  percent: _vm.progress.percent,
                  indeterminate: _vm.progress.indeterminate,
                  color: _vm.color
                }
              })
            : _vm._e(),
          !_vm.loadContent
            ? _c("div", { staticClass: "text-center" }, [
                _c(
                  "button",
                  { staticClass: "btn", on: { click: _vm.saveData } },
                  [_vm._v(" Aceptar ")]
                )
              ])
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }